import {AxiosError} from "axios";
import Cookies from "js-cookie";
import selectPaymentFlow from "../Api/Requests/select-payment-flow";
import postPaymentFailedStatusRequest from "../Api/Requests/post-payment-failed-status.request";

export type LiteUserInfo = {
    id: number;
    full_name: string;
    profile_picture: string;
    phone_number: string;
    member_type:number
};
  
export type AuthTicketType = {
    t: number;
    k: string;
};

type CookiesDataTypes = {
    userInfo : LiteUserInfo
    tgtTimestamp : any
    tgtTicket : any
    ecountry :string
    source:string
    device_uuid:string
    NEXT_LOCALE:string
    VIEWED_LISTING_COOKIE:string
    audience : string
    cityId : string
}

export const mustache = (string: string, data: Object) => {
    return Object.entries(data).reduce((res, [key, value]) => {
        const search = `{{${key}}}`

        if (
            res.indexOf(search) !== -1 &&
            res.indexOf(`\\${key}`) == -1 &&
            res.indexOf(`${key}\\`) == -1
        ) {
            return res.replace(search, value)
        }

        return res
    }, string)
}

export const check422Error = (error: AxiosError) => {

    if (error.response.data['statusCode'] == 422) {
        return true

    } else {
        return false
    }

}

export const getLang = (): string => {
    const urlParams = new URLSearchParams(window.location.search)
    const langParam = urlParams.get('lang')
    const langLocalStorage = localStorage.getItem('lang')
    let lang = 'ar'
    if (langParam) {
        lang = langParam
        localStorage.setItem('lang', langParam)
    } else if (langLocalStorage) {
        lang = langLocalStorage
    }
    return lang
}
export function getUrlBasedOnCountry(country: string,lang:string): string {
    let url = process.env.REACT_APP_BACK_BUTTON_REDIRECT as string
    url = url.replace("XX", country)
    url = url.replace("LANG", lang)
    return url;
}
function isValidHttpUrl(s) {
    let url;
    try {
        url = new URL(s);
    } catch (e) { return false; }
    return /https?/.test(url.protocol);
}

export const isDeviceMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent || ""
    );
  }

export const getCookies = () => {
    const data : CookiesDataTypes  =  {
        userInfo: jsonSafeGet<LiteUserInfo>(Cookies.get('userInfo')),
        tgtTimestamp: jsonSafeGet<AuthTicketType>(Cookies.get('auth')).t || Cookies.get('tgt_timestamp'),
        tgtTicket: jsonSafeGet<AuthTicketType>(Cookies.get('auth')).k || Cookies.get('tgt_ticket'),
        ecountry: Cookies.get('ecountry') ?? 'jo',
        source : Cookies.get('source') || Cookies.get('source') || (isDeviceMobile() ? 'mobile' : 'desktop'),
        device_uuid: Cookies.get('device_uuid') ?? '',
        NEXT_LOCALE:Cookies.get('NEXT_LOCALE') ?? 'ar',
        VIEWED_LISTING_COOKIE:Cookies.get('recentlyViewed') ?? 'recentlyViewed',
        audience:  Cookies.get('source') || (isDeviceMobile() ? 'mobile' : 'desktop'),
        cityId : Cookies.get('cityId') || '',
    }
    return data;
}

export const jsonSafeGet = <T>(jsonString : any, defaultData = {}): T => {
    let output = defaultData as T;
    try {
      output = JSON.parse(jsonString);
    } catch (e) {
      // do nothing.
    }
    return output;
  };


export const handlePaymentScreenAction = ({paymentSecret ,cartId ,modelId,widget, setLoading = null,navigate,referrerUrl}) => {
    setLoading && setLoading(true);
    selectPaymentFlow({
        paymentSecret: paymentSecret,
        cartId: cartId,
        modelId: modelId,
        data: widget.button.payload,
        referrerUrl : referrerUrl
    }).then((response) => {
        if (response.data.deepLink && response.data.deepLink.type === 'confirmCart') {
            postPaymentFailedStatusRequest({
                paymentSecret: paymentSecret
            }).then((response) => {
                if (response.data.redirect && response.data.headToPaymentMethods) {
                    navigate(`/select-payment-method/${response.data.memberId}/${response.data.cartId}/${response.data.uuid}`)
                } else {
                    setLoading && setLoading(false);
                    window.location.href = response.data.redirect;
                }
            })
        } else if (response.data.deepLink && response.data.deepLink.type === 'carReport') {
            window.location.href = process.env.REACT_APP_MY_REDIRECT_CAR_REPORTS;
        } else if (response.data.deepLink && response.data.deepLink.type === 'redirect') {
            window.location.href = response.data.deepLink.url;
        } else {
            window.location.href = getUrlBasedOnCountry(localStorage.getItem('countryCode')  ?? 'jo', getLang())
        }
    }).catch((error) => {
        setLoading && setLoading(false);
    })
}